import styles from "./Footer.module.css";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.brand}>
          <a href="#" className={styles.logo} aria-label="Back to top">
            Carrcraft<span className={styles.dot}>.</span>
          </a>
          <p className={styles.tagline}>
            Custom app & software development — Australia
          </p>
        </div>

        <nav className={styles.links} aria-label="Footer navigation">
          <a href="#about" className={styles.link}>About</a>
          <a href="#services" className={styles.link}>Services</a>
          <a href="#products" className={styles.link}>Products</a>
          <a href="#contact" className={styles.link}>Contact</a>
          <a
            href="mailto:info@carrcraft.com.au"
            className={styles.link}
          >
            info@carrcraft.com.au
          </a>
        </nav>

        <p className={styles.copy}>
          © {year} Carrcraft Studio Pty Ltd · www.carrcraft.com.au
        </p>
      </div>
    </footer>
  );
}
